// extracted by mini-css-extract-plugin
export default {"row":"SeparatorRow_row__7csLQ","label":"SeparatorRow_label__5PJVX","line":"SeparatorRow_line__2UD43"};